import { configureStore } from "@reduxjs/toolkit";

import outletDetailReducer from "./outletDetail/outletDetailSlice";
import walletReducer from "./wallet/walletSlice";

const store = configureStore({
  reducer: { outlet: outletDetailReducer, wallet: walletReducer },
});

export default store;
